import React from "react";
import Modal from "../../../../elements/Modal";
import ManageAccessControl from "../ManageAccessControl";

const ManageAccessControlModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl9" title={"Access Control"}>
      <ManageAccessControl
        getResponse={getResponse}
        close={close}
        data={data}
      />
    </Modal>
  );
};

export default ManageAccessControlModal;
